import moment from 'moment';
import { formati18nDate, getFormattedDateTime } from 'ecs-react-components/dist/index.es';

const filterNaAppointments = (appts, taskNames) =>
  appts.filter((appt) => {
    if (!appt.tasks || !appt.tasks.length) {
      return false;
    }
    if (taskNames && taskNames.length) {
      const valuableTasks = taskNames.filter((taskName) =>
        appt.tasks.find((task) => task.propertyCategoryId === taskName.key));
      return valuableTasks.length;
    }
    return false;
  });

const mapAppointments = (appointments, taskNames, language, nowDate) => {
  if (!appointments || appointments.length < 1) {
    return [];
  }
  const meaningfulAppts = filterNaAppointments(appointments, taskNames);
  return meaningfulAppts.map((appt) => {
    const mapped = { ...appt };
    const nowMoment = nowDate ? moment(nowDate) : moment();
    const apptDate = appt.actualDate || appt.targetDate;

    if (mapped.statusDesc === 'Completed') {
      mapped.dateStatus = 'completed';
    } else if (mapped.statusDesc === 'Missed') {
      mapped.dateStatus = 'missed';
    } else if (nowMoment.isAfter(apptDate)) {
      mapped.dateStatus = 'overdue';
      mapped.flag = true;
    } else {
      mapped.dateStatus = appt.actualDate ? 'scheduled' : 'recommended';
    }

    mapped.displayDate = getFormattedDateTime(appt.actualDate, appt.targetDate, language);

    mapped.isUpcoming = mapped.statusDesc === 'Pending' && mapped.dateStatus !== 'overdue';

    if (appt.provider) {
      const nameParts = appt.provider.split(',');
      mapped.provider = {
        first: (nameParts.length > 1 ? nameParts[1].trim() + ' ' : ''),
        last: (nameParts.length > 0 ? nameParts[0] : ''),
      };
    }
    return mapped;
  });
};

const mapTemplates = (config, language) => {
  if (!config || config.length < 1) {
    return [];
  }
  return config.map((template) => {
    const mapped = { ...template };
    // ie. ll - Dec 25, 2016
    mapped.displayEffectiveDate = formati18nDate(template.effectiveDate, language, 'll');
    return mapped;
  });
};

export const mapFollowUpPlan = (config, language, nowDate) => {
  if (!config) {
    return null;
  }
  const mapped = { ...config, displayStartDate: formati18nDate(config.startDate, language, 'll') };
  mapped.appointments = mapAppointments(config.appointments, config.taskNames, language, nowDate);
  mapped.templates = mapTemplates(config.templates, language);
  return mapped;
};
